/* eslint-disable */
import React, { Component } from "react";
import { isDesktop, isApp } from "../../utils";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import PropTypes from "prop-types";

let HeaderComponent;
//TODO: need to add dynamic import for component or route based
class Header extends Component {
  static contextTypes = {
    router: PropTypes.shape({
      staticContext: PropTypes.object,
    }),
  };

  componentWillMount() {
    // this is only available when rendering on the server
    const { staticContext } = this.context.router;
    if (staticContext) {
      HeaderComponent =
        (staticContext.globalConfig &&
          staticContext.globalConfig.isDesktop &&
          DesktopHeader) ||
        MobileHeader;
    } else {
      HeaderComponent = (isDesktop && DesktopHeader) || MobileHeader;
    }
  }

  render() {
    if (isApp) {
      return null;
    }
    return (
      <div className="nw-header-container">
        <HeaderComponent />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/component/Header/index.js